const theme = {
    colors: {
      white: '#FFFFFF',
      black: '#000000',
      purple: "#6533D1",
      lightPurple: "#A187E3",
      gray: "#D9D9D9",
      darkGray: '#6F6F6F'
    },
    sizes: {
      mobile: "767px",
      tablet: "992px",
      aboveTablet: "993px",
      aboveLargeTablet: "1024px",
      desktop: "1200px",
      largeDesktop: "1440px"
    }
  };
  
  export default theme;